"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var thesaurusCtrl = function($scope, $uibModalInstance, $q, $http, thesaurusParams, permissions) {
  var termHistory = [];
  var init = function() {
    $scope.query = "";
    $scope.per_page = 40;
    $scope.page = 1;
    $scope.count = 0;
    $scope.name = thesaurusParams.thesaurus_name;
    $scope.permissions = permissions;
    if (thesaurusParams.current_value) {
      $scope.query = thesaurusParams.current_value;
    }
    getSchema().then(function() {
      getList();
      if (thesaurusParams.current_id) {
        getTerm(thesaurusParams.current_id);
        $scope.showDetails = true;
      } else {
        $scope.showDetails = false;
        $scope.activeTerm = null;
      }
    });
  };
  $scope.hasPermission = hlp.hasPermission;
  var getTerm = function(id) {
    $http.get('/api/thesaurus/' + thesaurusParams.thesaurus_name + '/term/' + encodeURIComponent(id + '.json'), {}).success(function(data, status, headers, config) {
      $scope.fields = transform.fromSchema($scope.schema, data.term.values);
      $scope.selectTerm(data.term);
      $scope.termPaths = data.term_paths;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  var getList = function() {
    var deferred = $q.defer();
    $scope.loading = true;
    var params = {
      "query": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page,
      "only_parents": !$scope.query
    };
    $http.get('/api/thesaurus/' + thesaurusParams.thesaurus_name + '/term.json', {params: params}).success(function(data, status, headers, config) {
      $scope.terms = data.terms;
      $scope.chunks = _.chunk(data.terms, 2);
      $scope.count = data.count;
      $scope.thesaurusDisplayName = data.thesaurus.displayName;
      deferred.resolve();
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      deferred.reject();
    });
    return deferred.promise;
  };
  var getSchema = function() {
    return $http.get('/api/thesaurus/' + thesaurusParams.thesaurus_name + '/schema.json', {}).success(function(data, status, headers, config) {
      $scope.schema = data.schema;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.$watch('page', function() {
    getList();
  });
  $scope.selectTerm = function(term) {
    if (hlp.isSet($scope.activeTerm)) {
      $scope.activeTerm.selected = false;
    }
    $scope.activeTerm = term;
    $scope.id = term.id;
    $scope.shortName = term.shortName;
    $scope.longName = term.longName;
    $scope.description = term.description;
    $scope.synonyms = term.synonyms;
    $scope.broaderTerms = term.broaderTerms;
    $scope.subTerms = term.subTerms;
    $scope.lod_data = term.lod_data;
    if (typeof term.values != 'undefined') {
      $scope.values = term.values;
    } else {
      $scope.values = {};
    }
    term.selected = true;
    $scope.showDetails = true;
  };
  $scope.goBack = function() {
    if (termHistory.length > 0) {
      var id = termHistory.pop();
      getTerm(id);
      $scope.showDetails = true;
    } else {
      $scope.showDetails = false;
    }
  };
  $scope.goUp = function() {
    termHistory = [];
    $scope.showDetails = false;
  };
  $scope.clickTerm = function(term) {
    if ($scope.showDetails)
      termHistory.push($scope.id);
    getTerm(term.id);
  };
  $scope.toggleDetails = function(show) {
    $scope.showDetails = show;
    if (show == true) {
      getTerm($scope.thesaurus, $scope.activeTerm.id);
    }
  };
  $scope.refresh = function() {
    $scope.toggleDetails(false);
    $scope.page = 1;
    getList();
  };
  $scope.save = function() {
    $uibModalInstance.close($scope.activeTerm);
  };
  $scope.addTerm = function() {
    var values = {
      'id': $scope.query.toLowerCase(),
      'shortName': $scope.query,
      'longName': $scope.query,
      'preliminary': true
    };
    $http.post('/api/thesaurus/' + $scope.name + '/term.json', angular.toJson(values)).success(function(data, status, headers, config) {
      getList().then(function() {
        var addedTerm = $scope.terms[0];
        $scope.selectTerm(addedTerm);
        $scope.save();
      });
    }).catch(function(data, status, headers, config) {
      $scope.$dismiss('cancel');
    }).finally(function() {
      $scope.loading = false;
    });
  };
  init();
};
thesaurusCtrl.$inject = ['$scope', '$uibModalInstance', '$q', '$http', 'thesaurusParams', 'permissions'];
module.exports = thesaurusCtrl;
